module.exports = __webpack_public_path__ + "static/img/5.1eacac1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/99/zh/5.png
// module id = M3Sq
// module chunks = 0